import { render, staticRenderFns } from "./MissingPortingDataWrapper.vue?vue&type=template&id=687bb758&"
import script from "./MissingPortingDataWrapper.vue?vue&type=script&lang=js&"
export * from "./MissingPortingDataWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports